import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Image from './images/default_avatar1.png'
import Search from '../Search'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleLeft,
  faClock,
  faComments,
  faPlus,
  faReply,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { Card, Col, Row } from 'reactstrap'
import { addReply } from 'store/Comments/actions'
import { useDispatch } from 'react-redux'
import { addComment } from 'store/Comments/actions'
import { searchReplies } from 'store/Comments/actions'
import { saveComment } from 'store/Comments/actions'
import { deleteComment } from 'store/Comments/actions'
import { saveReply } from 'store/Comments/actions'
import { deleteReply } from 'store/Comments/actions'
import { getReplies } from 'store/Comments/actions'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { TextEditor } from '../Editor'

const filterMatch = (item, value) => {
  value = value?.toLowerCase()

  const text = item.content.text?.toLowerCase().indexOf(value)
  const childLen = item.content.children
    ? item.content.children.filter(
        (item) => item.content.text?.toLowerCase().indexOf(value) !== -1
      ).length
    : 0

  if (text !== -1) {
    return true
  }

  if (childLen > 0) {
    return true
  }

  return false
}

const Avatar = (props) => (
  <div className='topic-avatar-wrapper'>
    <img src={Image} alt='default' />
  </div>
)

export const User = (props) => (
  <div className='topic-user'>
    {props.hideAvatar ? null : props.avatar ? (
      <img src={props.avatar} alt='default ' />
    ) : (
      <Avatar />
    )}
    <div className='topic-user-info'>
      <h4>
        {console.log(props, 'leart54')}
        {props.first_name} {props.last_name}
      </h4>
      <p>{props.job_title}</p>
    </div>
  </div>
)

const Divider = () => (
  <div className='row'>
    <div className='col-12'>
      <div className='reply-post-divider'></div>
    </div>
  </div>
)

export const Time = (props) =>
  props.time ? (
    <p className='discussion-post-time reply-time'>
      <FontAwesomeIcon icon={faClock} />
      <span> {props.time}</span>
    </p>
  ) : null

const Header = ({ title, content, ...props }) => {
  let language = {}
  // eslint-disable-next-line no-unused-expressions
  props.language.language ? (language = props.language.language.data) : null

  return (
    <div className='topic-header-info'>
      <div className='container-fluid without-padding'>
        <Row>
          <Col md='12'>
            <Row>
              <Col md='12'>
                <Link
                  to='/discussions'
                  className='btn btn-info btn-icon discussion-go-back-btn filters__button shadow-none'
                >
                  <FontAwesomeIcon icon={faAngleLeft} />
                  <span>
                    {' '}
                    {language.general ? language.general.back : null}{' '}
                  </span>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md='2'>
            {content && content.user ? <User {...content.user} /> : null}
          </Col>
          <Col md='10'>
            <div className='container'>
              <Row>
                <Col md='12'>
                  <div className='top-title-info'>
                    <h2>{title ? title : null}</h2>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md='12'>
                  <div className='discussion-post-info'>
                    <Time time={props.time} />
                    <p className='discussion-post-replies'>
                      <FontAwesomeIcon icon={faComments} />
                      <span> {props.repliesCount}</span>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md='12'>
                  <div className='topic-description'>
                    {content && content.data ? (
                      <TextEditor content={content.data} readOnly={true} />
                    ) : null}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export const ButtonContainer = ({ parentId, id, ...props }) => (
  <div className='row'>
    <div className='col-12'>
      <div className='reply-form-buttons'>{props.children}</div>
    </div>
  </div>
)

export const Button = ({ icon, title, onClick }) => (
  <button
    onClick={onClick}
    title={title}
    className='btn btn-info btn-transparent reply-btn-helper filters__button shadow-none'
  >
    {icon === 'faReply' ? (
      <FontAwesomeIcon icon={faReply} />
    ) : (
      <FontAwesomeIcon icon={faTrash} />
    )}
  </button>
)

const ButtonText = ({ text, onClick }) => (
  <button onClick={onClick} className='btn btn-info '>
    <span>{text}</span>
  </button>
)

export const Post = ({ content, commentId, parentId, id, ...props }) => {
  let language = {}
  const dispatch = useDispatch()
  // eslint-disable-next-line no-unused-expressions
  props.language.language ? (language = props.language.language.data) : null
  return (
    <div className='row'>
      <div className='col-2'>
        {content.user ? (
          <User {...content.user} hideAvatar={commentId !== parentId} />
        ) : null}
      </div>
      <div className='col-10'>
        <div className='container'>
          <div className='row'>
            <div className='col-6'>
              <Time {...content} />
            </div>
            <div className='col-6'>
              {!props.edit ? (
                <div className='reply-button-wrapper'>
                  {!props.isReply ? (
                    <Button
                      onClick={() => {
                        dispatch(addReply(commentId, parentId, id))
                      }}
                      title='reply'
                      icon='faReply'
                    />
                  ) : (
                    ''
                  )}

                  {props.access === 1 ||
                  props.access === 4 ||
                  props.access === 5 ? (
                    <Button
                      onClick={() => {
                        props.delete === 'deleteComment'
                          ? dispatch(deleteComment(commentId, parentId, id))
                          : dispatch(deleteReply(commentId, parentId, id))
                      }}
                      title='delete'
                      icon='faTrash'
                    />
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
          <div className='row'>
            <div className='reply-content-wrapper'>
              <TextEditor
                content={content.data}
                autoFocus={props.edit}
                readOnly={!props.edit}
                commentId={commentId}
                onChange={props.onChange}
              />

              {(() => {
                let filtered = props.items.filter((reply) =>
                  filterMatch(reply, props.searchValue)
                )

                filtered = !parentId
                  ? filtered.filter((item) => !parentId)
                  : filtered.filter((item) => parentId === item.parentId)

                return filtered.map((reply, index) => {
                  const isReplyEmpty =
                    reply.content.text?.trim() === '' && reply.edit === false
                  return (
                    !isReplyEmpty && (
                      <div className='replies-wrapper' key={reply.id}>
                        <div className='container no-gutter'>
                          <Post
                            {...props}
                            {...reply}
                            parentId={reply.id}
                            commentId={commentId}
                            save={'saveReply'}
                            delete={'deleteReply'}
                            onChange={'onChangeReply'}
                            isReply={true}
                          ></Post>
                        </div>
                      </div>
                    )
                  )
                })
              })()}
            </div>
          </div>
          <div className='row'>
            {props.edit ? (
              <ButtonContainer>
                <ButtonText
                  onClick={() => {
                    props.save === 'saveComment'
                      ? dispatch(saveComment(commentId, parentId, id))
                      : dispatch(saveReply(commentId, parentId, id))
                  }}
                  text={language.general ? language.general.submit : null}
                  title='test'
                />
                <ButtonText
                  onClick={() => {
                    props.delete === 'deleteComment'
                      ? dispatch(deleteComment(commentId, parentId, id))
                      : dispatch(deleteReply(commentId, parentId, id))
                  }}
                  text={language.general ? language.general.cancel : null}
                  title='test'
                />
              </ButtonContainer>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

const Comments = ({ list, threads, ...props }) => {
  let language = {}
  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    dispatch(getReplies(id))
  }, [dispatch, id])

  // eslint-disable-next-line no-unused-expressions
  props.language.language ? (language = props.language.language.data) : null

  const thread = threads?.find((item) => item.id === +id)

  return (
    <div className='d-flex justify-content-center mt--5'>
      <Col xl='10' className='mb-3 '>
        <Card className='p-2'>
          <Header
            {...props}
            {...(thread || {})}
            repliesCount={list?.length}
            language={props.language}
          />
          <div>
            <div className='row m-0'>
              <Col md='6'>
                <Row className='topic-header-row'>
                  {props.access === 1 ||
                  props.access === 4 ||
                  props.access === 5 ? (
                    <button
                      onClick={() => dispatch(addComment())}
                      className='btn btn-info btn-icon btn-add-topic align-items-center  mr-3 filters__button shadow-none'
                      style={{ display: 'inline', marginBottom: '5px' }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                      <span>
                        {language.discussions
                          ? language.discussions.new_topic
                          : null}
                      </span>
                    </button>
                  ) : null}
                  <div
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                  >
                    <Search
                      placeholder={
                        language.discussions
                          ? language.discussions.search_topic
                          : null
                      }
                      value={props.searchValue}
                      onChange={(evt) =>
                        dispatch(searchReplies(evt.target.value))
                      }
                    />
                  </div>
                </Row>
              </Col>
            </div>
            {list
              .filter((comment) => filterMatch(comment, props.searchValue))
              .map((comment, index) => (
                <div key={comment.id}>
                  {index > 0 ? <Divider /> : null}
                  {console.log(comment, 'leart374')}
                  <Post
                    {...props}
                    {...comment}
                    items={comment.content.children}
                    save={'saveComment'}
                    delete={'deleteComment'}
                    commentId={comment.id}
                    parentId={comment.id}
                  />
                </div>
              ))}
          </div>
        </Card>
      </Col>
    </div>
  )
}

export default Comments
